import { useSelector } from 'react-redux';

// Selectors
import { getUserFlag } from 'Shared/selectors/user';

type Params = {
  flag: string;
};

export function useUserFlag({ flag }: Params) {
  const flagValue = useSelector(state => getUserFlag(state, { flag }));

  return flagValue || null;
}
